import Review from './review'

let instance

const initInstance = (questions) => {
  instance = new Review(questions)
}

const QuestionReview = function (questions) {
  if (!instance) {
    initInstance(questions)
  }
  return instance
}

QuestionReview.destroy = () => {
  instance = null
}

export default QuestionReview
export { QuestionReview }



// WEBPACK FOOTER //
// ./src/views/question-review/question-review.js